import useLanguage from "../i18n/useLanguage";
import React, { useState } from "react";

export default function PortfolioCard({
  title,
  description,
  category,
  imageUrl,
  image_url,
}) {
  const { t } = useLanguage();
  const [loaded, setLoaded] = useState(false);
  const finalImage = imageUrl || image_url;

  return (
    <div
      className="
        relative
        w-full
        max-w-[450px]
        aspect-[3/2]
        h-[220px] sm:h-[260px] md:h-[300px]
        border border-[#5A4800]
        overflow-hidden
        bg-black
      "
      style={{ borderRadius: "12px 16px 18px 12px" }}
    >
      {/* Skeleton */}
      {!loaded && (
        <div className="absolute inset-0 bg-neutral-900 animate-pulse" />
      )}

      {/* IMAGE */}
      <img
        src={finalImage}
        alt={`${title} — ${t(category)} ${t("oleh")} Titik Senyap Studio. ${t(description)}`}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        className={`
          absolute inset-0
          w-full h-full object-cover
          transition-opacity duration-700 ease-out
          ${loaded ? "opacity-100" : "opacity-0"}
        `}
        style={{ borderRadius: "12px 16px 18px 12px" }}
      />

      {/* Overlay gradient */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: `
            linear-gradient(
              105deg,
              rgba(76,69,69,0) 83.15%,
              rgba(222,221,220,0.20) 97.34%
            )
          `,
        }}
      />

      {/* Left gradient */}
      <div
        className="absolute top-0 left-0 w-1/2 h-full pointer-events-none"
        style={{
          background:
            "linear-gradient(347deg, rgba(0,0,0,0) 21.28%, rgba(255,223,162,0.20) 109.84%)",
        }}
      />

      {/* Category */}
      <div className="absolute top-0 left-0 p-3 z-10 text-white font-bold text-sm md:text-lg">
        {t(category)}
      </div>

      {/* Title + Description */}
      <div
        className="
          absolute left-0 bottom-1
          z-10 p-3 pr-2 md:pr-6 pt-10
          max-w-[52%] md:max-w-[48%]
        "
      >
        <div className="text-white font-bold text-lg md:text-[24px] mb-1">
          {title}
        </div>

        <div className="text-white text-[12px] md:text-[16px] leading-relaxed">
          {t(description)}
        </div>
      </div>
    </div>
  );
}
